import { render } from "./BTCellMobile.vue?vue&type=template&id=790fc0c4&scoped=true"
import script from "./BTCellMobile.vue?vue&type=script&lang=js"
export * from "./BTCellMobile.vue?vue&type=script&lang=js"

import "./BTCellMobile.vue?vue&type=style&index=0&id=790fc0c4&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790fc0c4"]])

export default __exports__